import React from 'react';
import { useReveal } from '../lib/useReveal';
const TESTIMONIALS = [{
  quote: 'Nunca pensé que mis productos podían verse así. Mis clientas me felicitan todo el tiempo.',
  name: 'Camila Fernández',
  province: 'Buenos Aires'
}, {
  quote: 'Empecé desde cero y ya estoy vendiendo box dulces. El paso a paso es increíble.',
  name: 'Sofía Giménez',
  province: 'Córdoba'
}, {
  quote: 'Ahora mis tortas parecen profesionales. Por fin me animé a cobrar lo que vale mi trabajo.',
  name: 'Valentina Rossi',
  province: 'Rosario'
}, {
  quote: 'Mi Instagram cambió muchísimo. Pasé de 200 seguidores a tener pedidos todas las semanas.',
  name: 'Martina López',
  province: 'Mendoza'
}];
export function TestimonialsSection() {
  const [ref, isVisible] = useReveal();
  return <section className="py-12 md:py-16 px-6 bg-gradient-to-b from-[#fce7e9]/40 to-[#fff8f9]" data-id="element-210">
      <div className="max-w-5xl mx-auto" data-id="element-211">
        <div className="text-center mb-8" data-id="element-212">
          <span className="inline-block text-[#e89aaa] text-xs font-bold tracking-[0.25em] uppercase mb-3" data-id="element-213">
            ♡ Lo que dicen ♡
          </span>
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#6b4f3a]" data-id="element-214">
            Testimonios <span className="italic text-[#e89aaa]" data-id="element-215">reales.</span>
          </h2>
        </div>

        <div ref={ref} className={`reveal grid grid-cols-1 md:grid-cols-2 gap-5 ${isVisible ? 'is-visible' : ''}`} data-id="element-216">
          {TESTIMONIALS.map((t, i) => <div key={i} className="bg-white rounded-3xl p-6 border border-[#f4b6c2]/30 shadow-[0_8px_30px_rgba(232,154,170,0.06)] relative" data-id="element-217">
              <span className="absolute top-2 left-5 text-[#f4b6c2] font-serif text-5xl leading-none select-none" data-id="element-218">
                "
              </span>
              <p className="font-serif italic text-base md:text-lg text-[#6b4f3a] leading-relaxed pt-5 pl-2" data-id="element-219">
                {t.quote}
              </p>
              <div className="mt-4 pt-4 border-t border-[#f4b6c2]/20 flex items-center justify-between gap-2" data-id="element-220">
                <div data-id="element-221">
                  <p className="text-sm font-bold text-[#6b4f3a]" data-id="element-222">{t.name}</p>
                  <p className="text-xs text-[#8b6f47]/70" data-id="element-223">
                    {t.province}, Argentina
                  </p>
                </div>
                <div className="flex gap-0.5 text-[#e89aaa] text-sm" data-id="element-224">
                  {'★★★★★'.split('').map((s, j) => <span key={j} data-id="element-225">{s}</span>)}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}